import React from "react";

export default function DocumentStats({ stats }) {
  const documentCount = stats?.documentCount || 0;
  const totalJokes = stats?.totalJokes || 0;
  const totalBits = stats?.totalBits || 0;
  const totalTimeDisplay = stats?.totalTimeDisplay || "0:00";

  return (
    <div className="flex items-center justify-end text-xs text-gray-500 whitespace-nowrap">
      <span><span className="font-bold text-blue-700">{documentCount}</span> Documents</span>
      <span className="mx-2 text-gray-300">|</span>
      <span><span className="font-bold text-blue-700">{totalJokes}</span> Jokes</span>
      <span className="mx-2 text-gray-300">|</span>
      <span><span className="font-bold text-blue-700">{totalBits}</span> Bits</span>
      <span className="mx-2 text-gray-300">|</span>
      <span><span className="font-bold text-blue-700">{totalTimeDisplay}</span> Time</span>
    </div>
  );
}